// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"5995154b","240":"addadd72","280":"712c86f9","287":"229a2e50","301":"b845e13b","308":"19e0c8c2","421":"4107c84e","471":"465231d1","559":"2b923dcc","677":"830d02eb","924":"21b47628"}[chunkId] + ".chunk.js";
};